import { cn as e } from "../shared/utils.js";
import { Tooltip as t } from "../tooltip/tooltip.js";
import { AlertCircleIcon as n, InfoCircleIcon as r } from "@systemeio/icons";
import { Fragment as i, jsx as a } from "react/jsx-runtime";
import { Prec as o, RangeSet as s, StateEffect as c, StateField as l } from "@codemirror/state";
import { GutterMarker as u, gutter as d } from "@codemirror/view";
import { createRoot as f } from "react-dom/client";
//#region src/tracking-code-input/diagnostics-gutter.tsx
function p(e) {
	let t = /* @__PURE__ */ new Map();
	for (let n of e) {
		let e = t.get(n.line);
		e ? e.push(n) : t.set(n.line, [n]);
	}
	let n = /* @__PURE__ */ new Map();
	return t.forEach((e, t) => {
		let r = e.filter((e) => e.severity === "error");
		if (r.length > 0) {
			n.set(t, {
				severity: "error",
				messages: r.map((e) => e.message)
			});
			return;
		}
		let i = e.filter((e) => e.severity === "info");
		i.length > 0 && n.set(t, {
			severity: "info",
			messages: i.map((e) => e.message)
		});
	}), n;
}
function m(e, t) {
	let n = p(t), r = [];
	return n.forEach((t, n) => {
		if (n < 1 || n > e.lines) return;
		let i = e.line(n).from;
		r.push(new _(t.severity, t.messages).range(i));
	}), s.of(r, !0);
}
function h({ messages: e }) {
	return e.length === 1 ? /* @__PURE__ */ a(i, { children: e[0] }) : /* @__PURE__ */ a("ul", {
		className: "list-disc space-y-1 pl-4",
		children: e.map((e, t) => /* @__PURE__ */ a("li", { children: e }, `${t}:${e}`))
	});
}
function g({ severity: t }) {
	return /* @__PURE__ */ a(t === "error" ? n : r, {
		className: e("block size-4 shrink-0", t === "error" ? "text-icon-error" : "text-icon-secondary"),
		width: 16,
		height: 16,
		"aria-hidden": !0
	});
}
var _ = class e extends u {
	constructor(e, t) {
		super(), this.severity = e, this.messages = t;
	}
	eq(t) {
		return t instanceof e && t.severity === this.severity && t.messages.length === this.messages.length && t.messages.every((e, t) => e === this.messages[t]);
	}
	toDOM(e) {
		let n = document.createElement("span");
		n.className = "cm-diagnosticMarkerHost", n.dataset.slot = "tracking-code-diagnostic-marker", n.dataset.severity = this.severity, n.style.display = "inline-flex", n.style.alignItems = "center", n.style.justifyContent = "center", n.style.width = "16px", n.style.height = "16px", n.style.minWidth = "16px", n.style.minHeight = "16px", n.style.flex = "0 0 16px", n.style.overflow = "visible", n.style.lineHeight = "0";
		let r = f(n);
		n.__diagnosticRoot = r;
		let i = this.messages.join("; ");
		return r.render(/* @__PURE__ */ a(t, {
			trigger: /* @__PURE__ */ a(g, { severity: this.severity }),
			content: /* @__PURE__ */ a(h, { messages: this.messages }),
			showArrow: !0,
			triggerProps: {
				className: "inline-flex size-4 shrink-0 cursor-default items-center justify-center border-0 bg-transparent p-0 outline-none",
				"aria-label": i
			},
			positionerProps: {
				side: "top",
				align: "start",
				sideOffset: 6
			},
			popupProps: { className: "text-sm font-medium" }
		})), n;
	}
	destroy(e) {
		let t = e, n = t.__diagnosticRoot;
		t.__diagnosticRoot = void 0, queueMicrotask(() => {
			n?.unmount();
		});
	}
}, v = new class e extends u {
	toDOM() {
		let e = document.createElement("span");
		return e.className = "cm-diagnosticMarkerSpacer", e.style.display = "inline-block", e.style.width = "16px", e.style.height = "16px", e;
	}
	eq(t) {
		return t instanceof e;
	}
}(), y = c.define(), b = l.define({
	create(e) {
		return {
			diagnostics: [],
			markers: m(e.doc, [])
		};
	},
	update(e, t) {
		let n = e.diagnostics, r = !1;
		for (let e of t.effects) e.is(y) && (n = e.value, r = !0);
		return r || t.docChanged ? {
			diagnostics: n,
			markers: m(t.state.doc, n)
		} : e;
	}
}), x = o.high([b, d({
	class: "cm-diagnosticGutter",
	markers: (e) => e.state.field(b).markers,
	initialSpacer: () => v
})]);
function S(e) {
	return y.of(e);
}
//#endregion
export { x as diagnosticGutterExtension, S as setDiagnosticMarkers };
